import styled from "styled-components";
import { colors } from "theme";

export const CardOption = styled.div`
  width: 30%;
  padding: 1.4rem;
  text-align: center;
  user-select: none;
  border: 1px solid ${colors.baseBlue};
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  background-color: ${(props) =>
    props.selected ? colors.baseBlue : "transparent"};
  color: ${(props) => (props.selected ? colors.whiteColor : colors.baseBlue)};
  transition: 0.2s ease-in-out all;
  /* &:hover {
    background-color: ${(props) =>
      props.selected ? "none" : colors.cardBackgroundColor};
    border: 1px solid
      ${(props) => (props.selected ? colors.baseBlue : colors.accentColor)};
    transform: scale(1.015);
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.1);
  } */
`;

export const CardSelectorWrapper = styled.div`
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
`;


const Radio = styled.section`
  background: ${(props)=>props.selected? colors.primaryColor : 'white'};
  border: 1px solid #231A3D;
  padding: 1.2rem;
  border-radius: 10px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  user-select: none;
  cursor: pointer;
  transition: 0.2s all ease-in-out;
  /* &:hover {
    background-color: #e6f0ff;
  } */
`;

const Image = styled.img`
  width: 2rem;
  margin-right: 2rem;
  user-select: none;
  pointer-events: none;
`;

const RadioListWrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1.8rem;
  margin-top: 2rem;
  max-width: 800px;
`;

export { Radio, Image, RadioListWrapper };

